import resources from '@/store/modules/resources.js'

export default {
  register: vueInstance => {
    vueInstance.$on('setPageTitle', setPageTitle)
  },
}

const setPageTitle = ({ context, path }) => {
  const titles = resources.state.resources.title.page
  const defaultTitle = 'TeamCulture'

  if (!context) return

  context.$once('hook:beforeDestroy', () => (document.title = defaultTitle))

  document.title = titles[path] || defaultTitle
}
